/**
 * Environment detection utilities
 */

/**
 * Check if code is running on the server (Node.js) vs client (browser)
 * @returns true if running server-side, false if running client-side
 */
export function isServerSide(): boolean {
  return typeof window === 'undefined';
}
